import './App.css';


import Rout  from './Routes/Rout';

function App() {
  return (
    <div className="App">
    <Rout/>
    </div>
  );
}

export default App;
